module.exports = __webpack_public_path__ + "assets/images/amira_view_report_default.dd1b451b17bbbd403dc7322266eb9ece.svg";